import { render, staticRenderFns } from "./MarketSettingTaskAreaAcc.vue?vue&type=template&id=56b8938f"
import script from "./MarketSettingTaskAreaAcc.vue?vue&type=script&lang=js"
export * from "./MarketSettingTaskAreaAcc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports